export const PASSWORD_MIN_LENGTH = 8;

/** At least 8 chars with uppercase, lowercase, and a digit. */
export const PASSWORD_POLICY_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

export const PASSWORD_POLICY_HINT =
  'At least 8 characters with uppercase, lowercase, and a number.';

export type PasswordPolicyCheck = {
  id: 'length' | 'upper' | 'lower' | 'digit';
  label: string;
  met: boolean;
};

export function getPasswordPolicyChecks(password: string): PasswordPolicyCheck[] {
  return [
    { id: 'length', label: `At least ${PASSWORD_MIN_LENGTH} characters`, met: password.length >= PASSWORD_MIN_LENGTH },
    { id: 'upper', label: 'One uppercase letter', met: /[A-Z]/.test(password) },
    { id: 'lower', label: 'One lowercase letter', met: /[a-z]/.test(password) },
    { id: 'digit', label: 'One number', met: /\d/.test(password) },
  ];
}

export function passwordMeetsPolicy(password: string): boolean {
  return PASSWORD_POLICY_REGEX.test(password);
}

export function assertPasswordMeetsPolicy(password: string): void {
  if (passwordMeetsPolicy(password)) return;
  throw new Error(PASSWORD_POLICY_HINT);
}
